<script setup lang="ts">
import { md } from "~/utils/breakpoints"

const props =
  defineProps<{
    pending: boolean
    stars: number
    ratings: number
  }>()
const { t } = useI18n()

const emit =
  defineEmits<{
    (e: "reviewsClick"): void
  }>()

const isDesktop = computed(() => md.value)
const hasRatingContent = computed(() => props.stars > 0 || props.ratings > 0)
const canOpenReviews = computed(() => props.ratings > 0)
</script>

<template>
  <SkeletonAnimatedPlaceholder
    v-if="pending"
    :height="isDesktop ? '24px' : '16px'"
    :width="isDesktop ? '100%' : '132px'"
    borderRadius="4px"
    :class="isDesktop ? 'mb-4 w-full' : 'stars-container mb-4 w-fit'"
  />

  <div
    v-if="hasRatingContent"
    class="stars-container mb-4 flex items-center gap-1 md:flex-nowrap"
  >
    <UtilsStars
      v-if="stars >= 0"
      :stars="stars"
      :size="isDesktop ? 6 : 4"
      :gap="1"
      preload-icons
    />

    <button
      v-if="ratings >= 0"
      type="button"
      class="
        mouse-medium-underlined
        text-green-main
        hover:text-green-300
        p-0
        leading-none
        disabled:cursor-default
      "
      :class="{ 'cursor-pointer': canOpenReviews }"
      :disabled="!canOpenReviews"
      @click="emit('reviewsClick')"
    >
      <span class="whitespace-nowrap">
        {{
          isDesktop
            ? `${ratings} ${t("productPage.detail.reviews", ratings)}`
            : ratings
        }}
      </span>
    </button>
  </div>
</template>
